/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  loginIntro: {
    defaultMessage: `But enough about me, who are you?`,
    id: 'app.login.form.intro'
  },
  formLabelId: {
    defaultMessage: `Identification Number (ID):`,
    id: 'app.login.form.id'
  },
  formLabelDOB: {
    defaultMessage: `Date of Birth:`,
    id: 'app.login.form.dob'
  },
  formButtonLogin: {
    defaultMessage: `Login`,
    id: 'app.login.form.login'
  },
  formErrorLogin: {
    defaultMessage: `ID is not registered or does not match.`,
    id: 'app.login.error.login'
  }
});



// WEBPACK FOOTER //
// ./src/containers/login/messages.js